var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"highcharts",style:(_vm.isVisible ? 'display: block' : 'display: none'),attrs:{"id":("highcharts-" + (this.type))}})}
var staticRenderFns = []

export { render, staticRenderFns }